export enum AmputationTypes {
  HAND_LEFT = 'linke Hand',
  HAND_RIGHT = 'rechte Hand',
  FOREARM_LEFT = 'linker Unterarm (+ linke Hand)',
  FOREARM_RIGHT = 'rechter Unterarm (+ rechte Hand)',
  UPPERARM_LEFT = 'linker Oberarm (+ linker Unterarm + linke Hand)',
  UPPERARM_RIGHT = 'rechter Oberarm (+ rechter Unterarm + rechte Hand)',
  FOOT_LEFT = 'linker Fuß',
  FOOT_RIGHT = 'rechter Fuß',
  LOWERLEG_LEFT = 'linker Unterschenkel (+ linker Fuß)',
  LOWERLEG_RIGHT = 'rechter Unterschenkel (+ rechter Fuß)',
  UPPERLEG_LEFT = 'linker Oberschenkel (+ linker Unterschenkel + linker Fuß)',
  UPPERLEG_RIGHT = 'rechter Oberschenkel (+ rechter Unterschenkel + rechter Fuß)',
  OTHER = 'sonstige Amputation',
}
